// Packages
import React from 'react';
// Configuration
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
// Services
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
// Components
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';
import BreadCrumbs from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/breadcrumbs';
import MainTitle from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/mainTitle';
import disableElementService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/disableElementService';

import ImageHeader from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/imageHeader';
import Skeleton from 'react-loading-skeleton';

export default class RainyDayRefundContent extends React.Component {
    constructor(props) {
        super(props);
        this.pathExtension = pageConfig.rainyDayRefundPage.initialPathExtension;
        this.state = {
            publicResources: props.temporaryPublicResourcesSSR || props.publicResourcesSSR || null,
            errorMsg: null,
            isLoading: null,
        };
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        const { publicResources } = this.state;
        if (!publicResources) {
            this.getData();
        }
        disableElementService.removeServerSideRenderClass();
        window.isReactLoaded = true;
    }

    getData() {
        this.setState({ isLoading: true });
        apiFetchData(this.pathExtension)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        publicResources: res.data,
                    });
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                this.setState({
                    errorMsg: err,
                });
                reportError(err);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    }

    render() {
        const { publicResources, errorMsg, isLoading } = this.state;

        return (
            <>
                <BreadCrumbs breadcrumbs={publicResources?.breadcrumbs} breadcrumbsStructuredData={publicResources?.breadcrumbsStructuredData} isLoading={isLoading} skeletonMaxWidthPx={190} />
                {isLoading && (
                    <div>
                        <div className="mb-3">
                            <Skeleton width={170} height={30} />
                        </div>
                        <div className="mb-4 skeletonHeaderImage">
                            <Skeleton width="100%" />
                        </div>
                        <Skeleton count={50} />
                    </div>
                )}
                {errorMsg && <AxiosError />}
                {publicResources && (
                    <div>
                        <div className="row pageContent">
                            {publicResources.mainTitle && (
                                <div className="col-12">
                                    <MainTitle title={publicResources.mainTitle} />
                                </div>
                            )}
                            <div className="col-md-12 aboutUsText">
                                <ImageHeader
                                    width={864}
                                    height={260}
                                    imagePath={publicResources.headerImage.sourceURL}
                                    imageALT={publicResources.headerImage.altText}
                                    imageTitle={publicResources.headerImage.titleText}
                                />
                                <div dangerouslySetInnerHTML={{ __html: publicResources.documentHTMLContent }} />
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
